var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "linkedin-tile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin-tile",
    fill: "#0077B5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2304688,12.9151473 L16.2304688,12.3671875 C16.2304688,11.8149028 15.7827535,11.3671875 15.2304688,11.3671875 L13.3632812,11.3671875 C12.8109965,11.3671875 12.3632812,11.8149028 12.3632812,12.3671875 L12.3632812,21.96875 C12.3632812,22.5210347 12.8109965,22.96875 13.3632812,22.96875 L15.2304688,22.96875 C15.7827535,22.96875 16.2304688,22.5210347 16.2304688,21.96875 L16.2304688,15.9618678 C16.4325588,15.0043396 17.1507414,14.1796875 18.28125,14.1796875 C19.6875,14.1796875 20.2148438,15.234375 20.2148438,16.8164062 L20.2148438,22.96875 L24.0820312,22.96875 L24.0820312,16.3476562 C24.0820312,12.7734375 22.2070312,11.1328125 19.6289062,11.1328125 C17.7161239,11.1328125 16.7216127,12.1591154 16.2304687,12.9151473 Z M5,0 L25,0 C27.7614237,-5.07265313e-16 30,2.23857625 30,5 L30,25 C30,27.7614237 27.7614237,30 25,30 L5,30 C2.23857625,30 -1.43817996e-15,27.7614237 -1.77635684e-15,25 L0,5 C-3.38176876e-16,2.23857625 2.23857625,-1.26909153e-15 5,-1.77635684e-15 Z M8.3203125,10.2539062 C9.51764858,10.2539062 10.4882812,9.28327358 10.4882812,8.0859375 C10.4882812,6.88860142 9.51764858,5.91796875 8.3203125,5.91796875 C7.12297642,5.91796875 6.15234375,6.88860142 6.15234375,8.0859375 C6.15234375,9.28327358 7.12297642,10.2539062 8.3203125,10.2539062 Z M7.38671875,11.3671875 C6.834434,11.3671875 6.38671875,11.8149028 6.38671875,12.3671875 L6.38671875,21.96875 C6.38671875,22.5210347 6.834434,22.96875 7.38671875,22.96875 L9.25390625,22.96875 C9.806191,22.96875 10.2539062,22.5210347 10.2539062,21.96875 L10.2539062,12.3671875 C10.2539062,11.8149028 9.806191,11.3671875 9.25390625,11.3671875 L7.38671875,11.3671875 Z",
    id: "Combined-Shape",
    transform: "translate(9,9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.051a9f60b306bc754bc2c6bc69a348af.svg";
export { ForwardRef as ReactComponent };